import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Download, ImageIcon, Loader2 } from 'lucide-react';

export default function ClickToPreviewImage({ src, alt, className = '' }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState(false);

  if (showErrorMsg) {
    return (
      <div className={`border-2 border-dashed border-red-200 rounded-xl flex flex-col items-center justify-center p-6 bg-red-50/50 text-red-500 ${className}`} style={{ minHeight: '160px' }}>
        <ImageIcon className="w-8 h-8 mb-2 opacity-60" />
        <p className="text-xs font-bold text-center">Preview gambar belum tersedia.</p>
        <p className="text-[10px] mt-1 text-center font-medium max-w-[200px]">Silakan unggah gambar melalui form edit atau hubungi tim terkait.</p>
      </div>
    );
  }

  if (!isLoaded) {
    return (
      <div className={`border border-slate-200 rounded-xl overflow-hidden relative group bg-slate-50 flex items-center justify-center cursor-pointer hover:bg-slate-100 transition-colors ${className}`} style={{ minHeight: '160px' }} 
        onClick={() => {
          if (!src) {
            setShowErrorMsg(true);
          } else {
            setIsLoading(true);
          }
        }}
      >
        <div className="text-center">
          {isLoading ? (
            <Loader2 className="w-8 h-8 mx-auto text-[#8C6208] mb-2 animate-spin" />
          ) : (
            <ImageIcon className="w-8 h-8 mx-auto text-slate-400 mb-2 group-hover:text-[#8C6208] transition-colors" />
          )}
          <p className="text-xs font-bold text-slate-500 group-hover:text-[#8C6208] transition-colors">
            {isLoading ? 'Memuat...' : 'Klik untuk memuat gambar'}
          </p>
          <p className="text-[10px] text-slate-400 mt-1">Menghemat data & memori server</p>
        </div>
        
        {/* Hidden image to trigger loading when state changes */}
        {isLoading && src && (
          <img 
            src={src} 
            alt={alt} 
            className="hidden" 
            onLoad={() => {
              setIsLoaded(true);
              setIsLoading(false);
            }}
            onError={() => {
              setIsLoading(false);
              setShowErrorMsg(true);
            }}
          />
        )}
      </div>
    );
  }

  return (
    <div className={`relative group border border-slate-200 rounded-xl overflow-hidden bg-white ${className}`}>
      <img src={src} alt={alt} className="w-full h-auto object-contain max-h-[400px]" />
      
      {/* Download Button Overlay */}
      <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center -[2px]">
        <Button 
          variant="secondary" 
          size="sm" 
          className="gap-2 font-bold shadow-xl rounded-full px-5"
          onClick={(e) => {
            e.stopPropagation();
            window.open(src, '_blank');
          }}
        >
          <Download className="w-4 h-4" /> Buka & Unduh
        </Button>
      </div>
    </div>
  );
}
